import './assets/main.css';
import './assets/fonts/fonts.css';
import { createApp } from 'vue';
import App from './App.vue';
import AppPlugin from './core/AppPlugin';
import { i18n } from '@/i18n';

const app = createApp(App);
app.use(AppPlugin);
app.use(i18n);

let appContainer = document.getElementById('coin-app');

if (!appContainer) {
	appContainer = document.createElement('div');
	appContainer.id = 'coin-app';
	document.body.appendChild(appContainer);
}

app.mount(appContainer);

// Show app info
console.log(
	// @ts-ignore
	`%cGrowth Drops > App Version: ${__APP_VERSION__}`,
	'border: 1px solid #E22134; padding: 4px 8px; font-weight: 600'
);

console.log(
	// `%cGrowth Drops > Git Branch/Git Commit: ${__BRANCH__} ${__COMMIT_HASH__} ${__TAG__}`,
	// @ts-ignore
	`%cGrowth Drops > Git Branch/Git Commit: ${__BRANCH__} ${__COMMIT_HASH__}`,
	'border: 1px solid #E22134; padding: 4px 8px; font-weight: 600'
);

console.log(
	`%cGrowth Drops > Build mode: ${import.meta.env.MODE}`,
	'border: 1px solid #E22134; padding: 4px 8px; font-weight: 600'
);
